<div class="header-buttons">

  <div class="header-button update-available-btn-wrapper" *ngIf="(layoutService.isUpdateAvailable$ | async)">
    <button class="update-available-btn" (click)="onUpdateAvailableClick()" [@expandWidth]>
      <fa-icon icon="sync-alt" class="margin-right-smallest"></fa-icon>
      Refresh to update
    </button>
  </div>

  <div class="header-button" *ngIf="displaySearchNavItem">
    <button class="search" (click)="onItemAction('toggleSearch'); $event.stopPropagation()" 
      nz-tooltip [nzTooltipTitle]="getSearchPlaceholder()" [nzTooltipPlacement]="'bottomRight'">
      <app-icon [icon]="'icon-search-circle'"></app-icon>
    </button>
  </div>

  <div class="header-button" *appFeatureToggle="'HelpCenter'">
    <button (click)="onHelpCenterClick()" nz-tooltip [nzTooltipTitle]="'Help Center'" [nzTooltipPlacement]="'bottomRight'">
      <app-icon [icon]="'icon-question-mark'"></app-icon>
    </button>
  </div>

  <div class="header-button">
    <button popovertarget="profile-menu" nz-tooltip [nzTooltipTitle]="'Account'" [nzTooltipPlacement]="'bottomRight'">
      <app-icon [icon]="'icon-profile'"></app-icon>
    </button>
  </div>

  <div class="profile-menu" popover id="profile-menu" #profileMenu>
    <ng-container *ngFor="let item of headerActions">
      <a (click)="onItemAction(item.actionId)"
          [routerLink]="getRouterLinkPath(item) || null"
          [queryParams]="getRouterLinkQueryParams(item) || null"
          [id]="item.id" [ngClass]="{'selected': item.isSelected !== undefined && item.isSelected}"
          class="profile-menu-item">
        {{item.label}}
      </a>
    </ng-container>
  </div>
</div> 